import Vue from 'vue'
import { $AxE2Loader, AxE2Loader } from './$AxE2Loader'
import { $AxE2Config, AxE2Config } from './$AxE2Config'
import { $axFrontendHelper, AxFrontendHelper } from './$axFrontendHelper'
import { $AxE2AppHooks } from './$AxE2AppHooks'
import { $appHook } from '@shared/model/$appHook'
import { $axAuthState } from './$axAuthStateManager'
import { $cart } from './$cart'
import { $urlHelper } from './$urlHelper'
import { $toast } from './$toast'

/**
 * Main hander of AxE2, ユーザからKickされるアクションは基本的にはこの中に入っている
 */
export class AxE2 {
  $loader: AxE2Loader
  $config: AxE2Config
  $api: AxFrontendHelper
  hooks: typeof $AxE2AppHooks
  $appHook: typeof $appHook
  $auth: typeof $axAuthState
  $cart: typeof $cart
  $urlHelper: typeof $urlHelper
  $toast: typeof $toast
  constructor() {
    this.$loader = $AxE2Loader
    this.$config = $AxE2Config
    this.$api = $axFrontendHelper
    this.hooks = $AxE2AppHooks
    this.$appHook = $appHook
    this.$auth = $axAuthState
    this.$cart = $cart
    this.$urlHelper = $urlHelper
    this.$toast = $toast
  }

  /**
   * ログイン判別を実施, colckeiにTokenがあれば、auth状態であると判定している。
   */
  get isLoggedIn(): boolean {
    return !!this.$auth.auth?.access_token
  }

  /**
   * Vueのレンダリング状態をRefreshする
   */
  $forceUpdate() {
    this.$loader.mainVueInstance.$forceUpdate()
  }
  /**
   * Vueのレンダリング状態をRefreshする for all
   */
  $forceUpdateAll() {
    Object.values(this.$loader.loadedVueInstances).map((vm) => vm.$forceUpdate())
  }
}

export const $AxE2 = Vue.observable(new AxE2())
